var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      staticClass: "home-footer-info",
      staticStyle: { flex: "none" },
      on: { click: _vm.editCoordinate }
    },
    [
      _vm.editingCoordinate
        ? _c(
            "v-layout",
            {
              directives: [
                {
                  name: "on-clickaway",
                  rawName: "v-on-clickaway",
                  value: _vm.cancelEdit,
                  expression: "cancelEdit"
                }
              ],
              staticStyle: { margin: "0 15px" }
            },
            [
              _c("label", { staticStyle: { "margin-right": "5px" } }, [
                _vm._v(_vm._s(_vm.labelY))
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.yCoordinate,
                    expression: "yCoordinate"
                  }
                ],
                class: { "required-fail": !_vm.validLatitude },
                staticStyle: {
                  width: "60px",
                  background: "#e8e8e8",
                  "margin-right": "15px"
                },
                attrs: { type: "number", id: "coordinateY", hideArrow: true },
                domProps: { value: _vm.yCoordinate },
                on: {
                  keyup: [
                    function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.saveCoordinate.apply(null, arguments)
                    },
                    function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "esc", 27, $event.key, [
                          "Esc",
                          "Escape"
                        ])
                      ) {
                        return null
                      }
                      return _vm.cancelEdit.apply(null, arguments)
                    }
                  ],
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.yCoordinate = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("label", { staticStyle: { "margin-right": "5px" } }, [
                _vm._v(_vm._s(_vm.labelX))
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.xCoordinate,
                    expression: "xCoordinate"
                  }
                ],
                class: { "required-fail": !_vm.validLongitude },
                staticStyle: { width: "60px", background: "#e8e8e8" },
                attrs: { type: "number", id: "coordinateX", hideArrow: true },
                domProps: { value: _vm.xCoordinate },
                on: {
                  keyup: [
                    function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.saveCoordinate.apply(null, arguments)
                    },
                    function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "esc", 27, $event.key, [
                          "Esc",
                          "Escape"
                        ])
                      ) {
                        return null
                      }
                      return _vm.cancelEdit.apply(null, arguments)
                    }
                  ],
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.xCoordinate = $event.target.value
                  }
                }
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("span", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.editingCoordinate,
            expression: "!editingCoordinate"
          }
        ],
        ref: "mouseCoordinates",
        attrs: { id: "mouse-position" }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d6e4ed92", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d6e4ed92","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Footer/Coordinates.vue
// module id = null
// module chunks = 